import fetch from '@/utils/fetch';

/**
 * 创建店铺
 *
 * @export
 * @returns
 */
export function liveShopCreate(data) {
  return fetch({
    url: '/api_live/aw/mul/ow/plat/shop/open/save',
    method: 'post',
    data,
  });
}

/**
 * 获取图片验证码
 *
 * @export
 * @param {any} data
 * @returns
 */
export function getImageCode(sessionId) {
  return `${process.env.VUE_APP_BASE_API}/api_saas_user//w/nwr/code/image?sessionId=${sessionId}`;
}

/**
 * 获取手机区号

 */
export function getPhoneCode() {
  return fetch({
    url: '/api_user/service/w/account/get_area_code',
    method: 'get',
    data: {},
  });
}

/**
 * 发送验证码
 *
 * @export
 * @param {any} data
 * @returns
 */
export function sendVerifyCode(data) {
  return fetch({
    url: '/api_saas_user/w/code/send/v2',
    method: 'post',
    data,
  });
}

/**
 * 获取七牛token
 *
 * @export
 * @returns
 */
export function getToken() {
  return fetch({
    url: '/saas/user/m/common/upload/token',
    // url: '/api_user/service/aw/mul/ow/common/get_token',
    method: 'post',
    data: {},
  });
}

/**
 * 获取已提交的开店信息
 *
 * @export
 * @returns
 */
export function getOpenShopInfo(data) {
  return fetch({
    url: '/api_live/aw/mul/ow/plat/shop/open/view',
    method: 'post',
    data,
  });
}
